import { useAtom } from "jotai";
import { serviceSync } from "../../services/sync.service";
import MessagingThreadName from "./MessagingHeader/MessagingThreadName";
import MessagingHeaderNetworkStatus from "./MessagingHeader/MessagingHeaderNetworkStatus";
import MessagingThread from "./MessagingBody/MessagingThread";
import { useCallback } from "react";
import { MessagingThreadLoadOlderMessagesResponse } from "./MessagingBody/MessagingThread.types";
import { libMisc } from "../../lib/misc";
import MessagingThreadViewImageMedia from "./MessagingBody/MessagingThread/MessagingThreadViewImageMedia";
import backPngPath from "./MessagingMessagesBody/back.png";
import MessagingThreadCategoryAssigment from "./MessagingMessagesBody/MessagingThreadCategoryAssigment";

export type MessagingMessagesBodyProps = {
}

export default function MessagingMessagesBody({ }: MessagingMessagesBodyProps) {
    const [name] = useAtom(serviceSync.atomCurrentConversationName);
    const [messageThreadKeyCounter] = useAtom(serviceSync.atomMessageThreadKeyCounter);
    const [messages] = useAtom(serviceSync.atomMessages);

    const loadOlderMessagesHandler = useCallback(async () => {
        return new Promise<MessagingThreadLoadOlderMessagesResponse>(async (resolve) => {
            await libMisc.wait(1000);
            resolve(serviceSync.loadOlderMessages());
        });

    }, [messages]);

    return (
        <div className="flex flex-col w-full h-full relative"
            style={{
                backgroundImage: `url(${backPngPath})`,
                backgroundRepeat: 'repeat',
                backgroundSize: '180px 180px',
            }}>
            <div className="basis-[70px] flex justify-between items-center bg-[#f6f6f6]">
                <MessagingThreadName name={name.trim() || "(unknown)"} />
                {/* <MessagingThreadCategoryAssigment /> */}
            </div>
            <div className="flex-grow border-t border-gray-300 relative">
                <div className="absolute left-0 top-0 w-full h-full">
                    <MessagingThread key={messageThreadKeyCounter} messages={messages} onLoadOlderMessages={loadOlderMessagesHandler} />
                </div>
            </div>
            <MessagingThreadViewImageMedia />
        </div>
    );
}